import { useCountUp } from '../lib/useCountUp';

/** Running score, counted up when points land. Three zero-padded digits keep the width stable. */
export function ScoreBox({ score, reducedMotion }: { score: number; reducedMotion: boolean }) {
  const shown = useCountUp(score, 700, reducedMotion);
  return (
    <div
      className="flex min-w-[4.5rem] flex-col items-center rounded-xl border-2 border-accent/70 bg-ink/80 px-2 py-1 shadow-[0_0_18px_rgba(245,179,1,0.25)]"
      aria-live="polite"
      aria-label={`Score ${score}`}
    >
      <span className="text-[10px] font-bold tracking-[0.2em] text-accent">SCORE</span>
      <span className="font-mono text-2xl leading-none font-bold tabular-nums" data-testid="score">
        {String(shown).padStart(3, '0')}
      </span>
    </div>
  );
}
